import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Col, Card } from 'react-bootstrap';
export const ShowcaseHeader = () => (_jsx(_Fragment, { children: _jsx(Col, Object.assign({ md: '12' }, { children: _jsx(Card, Object.assign({ className: 'p-3 mb-1' }, { children: _jsx("h4", { children: "DEV SHOWCASE" }) })) })) }));
